import { render } from "./MarketplaceLogin.vue?vue&type=template&id=966e6b6e&scoped=true&lang=html"
import script from "./MarketplaceLogin.vue?vue&type=script&lang=js"
export * from "./MarketplaceLogin.vue?vue&type=script&lang=js"

import "./MarketplaceLogin.vue?vue&type=style&index=0&id=966e6b6e&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966e6b6e"]])

export default __exports__